import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TestCaseService } from '../../../services/test-case.service';

const LABEL_WITHOUT_KEY = 'header.breadcrumb.testCaseFormEdit';

export const testCaseKeyBreadcrumbResolver: ResolveFn<string> = (route) => {
  const projectId = route.pathFromRoot.map((r) => r.paramMap.get('projectId')).find(Boolean) ?? '';
  const testCaseId = route.paramMap.get('id') ?? '';
  const translate = inject(TranslateService);
  return inject(TestCaseService)
    .getById(projectId, testCaseId)
    .pipe(
      switchMap((testCase) =>
        testCase.key
          ? translate.get('header.breadcrumb.testCaseFormEditKey', { key: testCase.key })
          : of(LABEL_WITHOUT_KEY),
      ),
      catchError(() => of(LABEL_WITHOUT_KEY)),
    );
};
